<script>
/**
 * Users Data component
 */
import EditModal from "./update-user.vue";
import { authComputed, usersMethods } from "@/state/helpers";
export default {
  props: ["users", "busy", "loaderStatus"],
  components: {
    EditModal,
  },
  data() {
    return {
      user: {},
      usersList: [],

      currentPage: 1,
      perPage: 6,
    };
  },
  computed: {
    ...authComputed,
    fieldsComputed() {
      return [
        { key: "fullName", sortable: false, label: this.$t("dataTable.name.text"), class: "tdClass" },
        { key: "email", sortable: false, label: this.$t("dataTable.email.text"), class: "tdClass" },
        { key: "role", sortable: false, label: this.$t("dataTable.role.text"), class: "tdClass" },
        { key: "actions", sortable: false, label: this.$t("dataTable.tools.text"), class: "tdClass" },
      ];
    },
    userRole() {
      return this.loggedIn.user.role;
    },
  },
  mounted() {},
  methods: {
    ...usersMethods,
    showModalEdit() {
      this.$bvModal.show("edit-user-modal");
    },
    hideModalEdit() {
      this.$bvModal.hide("edit-user-modal");
    },
    edit(user) {
      this.updateUser(user)
        .then((user) => {
          this.makeToast(
            "Update user",
            user.fullName + " has been updated",
            "success"
          );
        })
        .catch((error) => {
          this.makeToast("Update user", error, "danger");
        });
    },
    passUser(type, user) {
      if (type == "edit") {
        this.user = user;
        this.showModalEdit();
      } else if (type == "delete") {
        this.$swal
          .fire({
            title: this.$t('modals.askValidDelete.text'),
            text: this.$t('modals.cantRevert.text'),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("buttons.validDelete.text"),
            cancelButtonText: this.$t("buttons.cancel.text"),
            showLoaderOnConfirm: true,
            preConfirm: () => {
              this.delUser(user.id)
                .then((response) => {
                  return response;
                })
                .catch((error) => {
                  this.$swal.showValidationMessage(`Request failed: ${error}`);
                });
            },
            allowOutsideClick: () => !this.$swal.isLoading(),
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$swal.fire(
                "Deleted!",
                "The user has been deleted.",
                "success"
              );
            }
          })
          .catch((error) => {
            this.makeToast("Alert Error", error, "danger");
          });
      }
    },
    makeToast(title, msg, variant) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
    rowClicked(record) {
      //this.$router.push({name:'alert', params: { serial: record.serial }})
      console.log(record);
    },
  },
  watch: {
    users(newVal) {
      this.usersList = newVal;
    },
  },
};
</script>

<template>
  <div>
    <div
      class="table-responsive mb-3 bg-white rounded-lg"
      style="min-height: 430px"
    >
      <b-table
        class="mb-0"
        hover
        show-empty
        centred
        :busy="busy"
        :empty-text="$t('dataTable.noUsers.text')"
        :current-page="currentPage"
        :per-page="perPage"
        :items="usersList"
        :fields="fieldsComputed"
        v-bind:style="{ cursor: `pointer` }"
        stacked="sm"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <strong>{{$t('dataTable.loading.text')}}</strong>
          </div>
        </template>
        <template v-slot:cell(actions)="data">
          <div class="d-inline-flex align-items-center">
            <b-button
              v-if="userRole != 'ADMIN'"
              type="button"
              class="mr-2"
              variant="light"
              @click="passUser('edit', data.item)"
              >{{$t("buttons.edit.text")}}
            </b-button>
            <b-button
              v-if="
                userRole == 'ADMIN' &&
                !['SYSADMIN', 'MANAGER'].includes(data.item.role)
              "
              type="button"
              class="mr-2"
              variant="light"
              @click="passUser('edit', data.item)"
              >{{$t("buttons.edit.text")}}
            </b-button>
            <b-button
              v-if="userRole == 'SYSADMIN'"
              type="button"
              variant="danger"
              @click="passUser('delete', data.item)"
              >{{$t("buttons.delete.text")}}
            </b-button>
            <b-button
              v-if="
                userRole == 'ADMIN' &&
                !['SYSADMIN', 'MANAGER'].includes(data.item.role)
              "
              type="button"
              variant="danger"
              @click="passUser('delete', data.item)"
              >{{$t("buttons.delete.text")}}
            </b-button>
          </div>
        </template>
      </b-table>
      <EditModal v-bind:user="user" @editUser="edit" />
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="users.length"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.tdClass {
  text-align: center;
}
</style>